import { TagColor as Color } from '@factorialco/deprecated-design-system'
import { PerformanceReviewProcessStatusEnum } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

const getStatusMappings = (): Record<
  PerformanceReviewProcessStatusEnum,
  { color: Color; label: string }
> => ({
  ['draft']: {
    color: Color.champagne,
    label: i18n.t('performance_process.reviews.review_status.draft'),
  },
  ['scheduled']: {
    color: Color.purple,
    label: i18n.t('performance_process.reviews.review_status.scheduled'),
  },
  ['active']: {
    color: Color.correct,
    label: i18n.t('performance_process.reviews.review_status.active'),
  },
  ['finished']: {
    color: Color.grey,
    label: i18n.t('performance_process.reviews.review_status.finished'),
  },
})

export const tagColor = (reviewStatus: PerformanceReviewProcessStatusEnum): Color => {
  const mapping = getStatusMappings()[reviewStatus]
  return mapping ? mapping.color : Color.grey
}

export const tagLabel = (reviewStatus: PerformanceReviewProcessStatusEnum) => {
  const mapping = getStatusMappings()[reviewStatus]
  return mapping ? mapping.label : i18n.t('performance_process.reviews.review_status.unknown')
}
